import { type CarrierDef } from '../common.js'
import { type RoadVisionCredTypes, roadVision } from '../standards.js'

export type zpxsCredType = RoadVisionCredTypes
export const zpxs: CarrierDef<zpxsCredType> = {
  name: 'Zip Xpress',
  scac: 'zpxs',
  ...roadVision,
  engineLayers: ['rating'],
}
